import { AppDataComponent, CompRef } from '@wix/document-services-types';
import {
  AppInstallOption,
  PluginInstallationParams,
} from '@wix/editor-platform-host-integration-apis';
import {
  autoInstallWithNavigation,
  autoInstall,
} from '../../../plugins/pluginAutoPopulateService';
import { getAllPluginsInstallationParams } from './pluginService';
import { ExtendedPlatformContext } from '../../../../../types/platformApi';
import { HEADER_SYSTEM_SLOT } from '../../../plugins/constants';

export async function autoPopulatePlugins(
  context: ExtendedPlatformContext,
  appsOptions: AppInstallOption,
  appDefinitionId: string,
  components: AppDataComponent[],
): Promise<void> {
  const pluginInstallationParams = await getAllPluginsInstallationParams(
    context.documentServices,
    context.manifestAPI,
    appDefinitionId,
    components,
    context.platformApiMethods,
    context.experimentsAPI,
    appsOptions,
    (slotId) => slotId !== HEADER_SYSTEM_SLOT.id,
  );

  if (!pluginInstallationParams || pluginInstallationParams.length === 0) {
    return Promise.resolve();
  }

  for (const [index, params] of pluginInstallationParams.entries()) {
    await handleSinglePlugin(
      context,
      appsOptions,
      params,
      index,
      pluginInstallationParams.length,
    ).catch((e) => {
      console.error('Failed to auto populate plugin', {
        error: e,
        params,
      });
    });
  }
}

async function handleSinglePlugin(
  context: ExtendedPlatformContext,
  appsOptions: AppInstallOption,
  params: PluginInstallationParams,
  index: number,
  totalPluginsCount: number,
): Promise<CompRef | null> {
  const shouldNavigate =
    !appsOptions?.pluginsAutoPopulate?.isSilent &&
    index === totalPluginsCount - 1;
  const biOrigin = appsOptions?.biData?.origin || 'appMarket';
  const populateMethod = shouldNavigate
    ? autoInstallWithNavigation
    : autoInstall;

  return populateMethod(
    context,
    context.documentServices,
    context.manifestAPI,
    params,
    {
      biOrigin,
      controlMode: 'user',
    },
    context.experimentsAPI,
  );
}
